// Account-only enrollment's link page and sign-in lines (Viewing Room VR-7), approved
// verbatim: docs/design/tuw/viewing-room/wording.md §6 `vr.confirmation.*`
// and §12 `vr.error.confirmation_limited`. Lines §6 reuses from Open House's
// guest-wording come from CONFIRMATION and REGISTRATION, so they stay one source.
import { CONFIRMATION as C, REGISTRATION as R } from "./wording"

export const ENROLLMENT_CONFIRMATION = {
  linkTitle: "Confirm your email to continue",
  linkBody: "Enter the password you created for your account to confirm your email and continue.",
  linkPassword: C.linkPage.passwordLabel,
  linkPasswordIncorrect: C.linkPage.passwordIncorrect,
  linkPasswordLimited:
    "You’ve entered the wrong password too many times. You can still use the confirmation code on the device where you created your account, or wait and try again later.",
  submit: "Confirm email and continue",
  submitting: C.submitting,
  linkInvalid: C.link.invalid,
  linkExpired: C.link.expired,
  alreadyConfirmedTitle: C.alreadyConfirmed.heading,
  confirmedElsewhere: "Your email is confirmed. Sign in here to continue where you left off.",
  signInContinue: R.existingButton,
  noPendingAccount:
    "There’s no account waiting for confirmation here. If you’ve already confirmed your email, sign in to continue.",
  accountConflict: "We couldn’t confirm this account. Contact TUW support for help.",
  confirmationLimited: (seconds) =>
    `There have been too many confirmation attempts. Try again in ${seconds} seconds.`,
  failed: C.failed,
  requiredBeforeSignIn: "Confirm your email before continuing to your account.",
  linkHelp: C.linkHelp,
}
